import type { FC } from 'react';
import { useRef } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import Slider from '@wix/da-ds/pkg/Slider';
import { DeviationLink } from '@wix/da-shared-react/pkg/Duperbrowse';
import PostCompactCard from '@wix/da-shared-react/pkg/PostCompactCard';

import s from './DywPostsSlider.scss';

export interface Props {
  posts: PapiDeviation[];
  className?: string;
  viewAllHref?: string;
}

const DywPostsSlider: FC<Props> = ({ posts, className, viewAllHref }) => {
  const { t } = useTranslation();

  const sliderRef = useRef<HTMLDivElement>(null);

  if (!posts.length) {
    return null;
  }

  const sliderItems = posts.map(post => (
    <div key={post.deviationId} className={s['post-card']}>
      <DeviationLink deviation={post} title={post.title}>
        <PostCompactCard
          deviation={post}
          className={s['post-compact-card']}
          showUsername
        />
      </DeviationLink>
    </div>
  ));

  if (viewAllHref && sliderItems.length > 9) {
    sliderItems.push(
      <a key="view-all" className={s['view-all-slide']} href={viewAllHref}>
        {t('common.viewAll')}
      </a>
    );
  }

  return (
    <section className={classnames(s['root'], className)}>
      <div className={s['slider-wrapper']} ref={sliderRef}>
        <Slider className={s['slider']} contentClassName={s['slider-content']}>
          {sliderItems}
        </Slider>
      </div>
    </section>
  );
};

DywPostsSlider.displayName = 'DywPostsSlider';

export default DywPostsSlider;
